/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/style-prop-object */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { notification } from "antd";
import { fetchApi } from "../../_config/api";
import {
  Card,

} from "../../library";
import { ProjectInfo } from "./projectInfo";
import "./styles.less";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  DEVELOPERROLE,
  getUserDetails,
  dateformatter,
} from "../../deps";
import DocImage  from "../../../assets/images/doc.png";
import DiscordImage from "../../../assets/images/discorddoc.png";
import Skeleton from "react-loading-skeleton";

export const ProjectDetails = ({ showLoader,isLoading }) => {
  const { pathname } = useLocation();
  const [projectId, setProjectId] = useState("");
  const [projectDetails, setProjectDetails] = useState({});
  const { userRole = DEVELOPERROLE, subscriptionId } = getUserDetails().profile || {};
  const [pageSetting, setSetting] = React.useState({
    page: 1,
    itemsPerPage: 10,
    searchText: "",
    filterValue: "",
  });
  const startIndex = (pageSetting.page - 1) * pageSetting.itemsPerPage;
  const [cardDetails, setCardDetails] = React.useState({});
  const discordurl = process.env.REACT_APP_DISCORD_URL;
  const faqurl = process.env.REACT_APP_FAQ_URL;

  useEffect(() => {
    const paths = pathname?.slice?.(1).split?.("/");
    if (paths && paths.length === 2) {
      setProjectId(paths[1]);
    }
  }, [pathname]);

  useEffect(() => {
    if (projectId) {
      getProjectDetails();
      // getActivityList();
      getCardDetails();
    }
  }, [projectId]);

  const getProjectDetails = () => {
    showLoader(true);
    fetchApi({ method: "GET", url: `developer/projects/${projectId}` })
      .then((response) => {
        if (response.doc !== null) {
          setProjectDetails(response.doc);
        }
        showLoader(false);
      })
      .catch(() => {
        showLoader(false);
      });
  };

  const onCopy = (apiKey) => {
    navigator.clipboard.writeText(apiKey);
    notification.success({
      message: "Copied to clipboard",
      duration: 3,
    });
  };

  const getCardDetails = async () => {
    showLoader(true);
    try {
      const response = await fetchApi({
        method: "GET",
        url: `projects/cardDetails/project?projectID=${JSON.stringify(projectId)}`,
        isDevApp: false,
      });
      if (response.statusCode === 200) {
        setCardDetails(response.docs);
        showLoader(false);
      }
    } catch (error) {
      // TypeError: Failed to fetch
      showLoader(false);
      notification.error({
        message: error.toString(),
        duration: 3,
      });
    }
  };
  const onExport = () => {
    showLoader(true);
    fetchApi({
      method: "GET",
      url: `projects/${projectId}/exportConfig`,
    })
      .then((response) => {
        const dataStr =
          "data:text/json;charset=utf-8," +
          encodeURIComponent(JSON.stringify(response));
        const projectExport = document.getElementById("projectExport");
        projectExport.setAttribute("href", dataStr);
        projectExport.setAttribute("download", `${projectDetails?.projectName}.json`);
        projectExport.click();
        showLoader(false);
        notification.success({
          message: "Successfully exported",
          duration: 3,
        });
      })
      .catch(() => {
        showLoader(false);
        notification.error({
          message: "Something went wrong. Please try again",
          duration: 3,
        });
      });
  };


  return (
    <div className="project-details-container">
      <a id="projectExport" style={{ display: "none" }} />
     {/* <div className="name-container marginBtm30">
        <div className="name-section">
          <div className="name">dApp Dashboard : {projectDetails?.projectName}</div>
        </div>
        <div className="btn-section">
        </div>
      </div>*/}
      {/*<div className="card-container marginBtm50">
      {isLoading?(<Skeleton height={124} baseColor="#262626" highlightColor="#404040" ></Skeleton>):(
        <Card
          type="endpoints"
          count={cardDetails?.endpointCount}
          text="Endpoints"
          color="purple"
        />)}
        {isLoading?(<Skeleton height={124} baseColor="#262626" highlightColor="#404040" ></Skeleton>):(
        <Card
          type="did-manager"
          count={cardDetails?.totalRequest}
          text="Requests"
          color="purple"
        />)}
        {isLoading?(<Skeleton height={124} baseColor="#262626" highlightColor="#404040" ></Skeleton>):(
        <Card
          type="disabled"
          count={cardDetails?.usedAPICredits}
          text="Credit Used"
          color="orange"
        />)}
        {isLoading?(<Skeleton height={124} baseColor="#262626" highlightColor="#404040" ></Skeleton>):(
        <Card
          type="request"
          count={cardDetails?.percentageCreditUsed}
          text="% of Credit Usage"
          color="blue"
        />)}
      </div>*/}
      {/*<div
        className="api-row-container"
        style={{
          display: "flex",
          flexDirection: "row",
          flex: "1",
          width: "100%",
        }}
      >

      </div>*/}
      
      <ProjectInfo
        text="Project"
        tooltip="This is a summary of the projects created by you along with relevant information like protocol used, wallet, storage and the API Key."
        item={projectDetails}
        isLoading={isLoading}
        reload={getProjectDetails}
        onCopy={onCopy}
        onExport={onExport}
        cardDetails={cardDetails}
      />
      <div className="proj-footer-container" style={{marginTop:"150px"}}>
        <div className="">
            <h1 className="header-3">Need some help ?</h1>
            <p className="subheader">Explore our resource page for support.</p>
        </div>
        <div className="project-footer-container" style={{display:"block",width:"80%"}}>
          <div className="tiles">
          {isLoading?(<Skeleton height={100} width={300} baseColor="#262626" highlightColor="#404040" ></Skeleton>):(
            <article className="tile tile-small">
                    <a href={faqurl} target="_blank"><img src={DocImage} /></a>
                  {/*<div className="tile-header">
                    <i className="ph-lightning-light" />
                    <span>FAQ</span>
                  </div>*/}
                  {/*<a href={faqurl} target="_blank">
                    <span><img src={require("../../../assets/images/question.avif")} /></span>
                    <span className="icon-button"><ArrowRightOutlined /></span>
                  </a>*/}
            </article>)}
            {isLoading?(<Skeleton height={100} width={300} baseColor="#262626" highlightColor="#404040" ></Skeleton>):(
            <article className="tile tile-small">
                <a href={discordurl} target="_blank"><img src={DiscordImage} /></a>
              {/*<div className="tile-header">
                <i className="ph-fire-simple-light" />
                <span>Discord</span>
              </div>*/}
              {/*<a href={discordurl} target="_blank">
                <span><Discord /></span>
                <span className="icon-button"><ArrowRightOutlined /></span>
              </a>*/}
            </article>)}
            <div>
            </div>
          </div>
            <div className="tiles">
                <div className="doc-div">
                    <h1 className="header-3">Documentation</h1>
                    <p className="subheader">Get familiar with all the features or learn how to start integrating them</p>
                </div>
                <div className="doc-div">
                    <h1 className="header-3">Community</h1>
                    <p className="subheader">Beyond the website. Explore more in our Discord Community</p>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;
